module.exports = __webpack_public_path__ + "img/category-brand-hover.2869d61d.png";